import { render } from "./Motherboard.vue?vue&type=template&id=c0aeddcc"
import script from "./Motherboard.vue?vue&type=script&lang=js"
export * from "./Motherboard.vue?vue&type=script&lang=js"

import "./Motherboard.vue?vue&type=style&index=0&id=c0aeddcc&lang=css"

import exportComponent from "/data/vstsagent02/user/3205/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__